import { useEffect, useState } from "react";
import { GD } from "src/GD";

export const useAPI = <T,>(initialRequest: IAPIRequest | null, dependency?: any[]) => {
	const [response, setResponse] = useState<IAPIResponse<T> | null>(null);
	const [request, setRequest] = useState<IAPIRequest | null>(initialRequest);
	const [busy, setBusy] = useState(false);

	useEffect(() => {
		if (request) executeRequest(request);
	}, [request, ...(dependency || [])]);

	const executeRequest = async (req?: IAPIRequest | null) => {
		if (req) setRequest(req);
		if (!req) req = request;
		if (!req) return;

		setBusy(true);
		const res = await GD.REQ_API.request(req);
		setResponse(res);
		setBusy(false);
		return res;
	};

	const resetData = () => {
		setResponse(null);
		setRequest(null);
		setBusy(false);
	};

	return [response, executeRequest, busy, resetData] as const;
};
